import axios from "axios";
import { useMutation } from "@tanstack/react-query";
import { API_BASE_PATH, API_BASE_RELATIVE_PATH } from "../Config/Config";

const bulkEditKeywordAction = async ({ testCaseId, data, Keyword, Action, subAction }) => {
  const userDetailString = localStorage.getItem("userDetail");
  if (!userDetailString) throw new Error("No user details found in localStorage");

  const user = JSON.parse(userDetailString);

  const response = await axios.post(
    `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=updateBulkKeywordsAndAction&companyid=${user.companyid}&testCaseId=${testCaseId}&Keyword=${Keyword}&Action=${Action}${subAction ? `&subAction=${subAction}` : ""}`,
    data,
  );

  return response.data;
};

const useBulkEditKeywordAction = () => {
  return useMutation({
    mutationFn: (variables) => bulkEditKeywordAction(variables),
  });
};

export default useBulkEditKeywordAction;
